import { createSelector } from 'reselect';

export const getNotification = state => state.notification;

export const getMessages = createSelector(getNotification, state => {
  return state.messages;
});

export default {
  getNotification,
  getMessages,
};
